(function () {
  'use strict'

  var MODULE_NAME = 'thismoment.content.content-api'

  angular
    .module(MODULE_NAME, [
      require('../api/async')
    ])
    .factory('ContentApi', contentService)

  contentService.$inject = ['SdkConfig', 'ThismomentAsyncApi']
  function contentService (SdkConfig, ThismomentAsyncApi) {
    var API = ThismomentAsyncApi.configureResource(SdkConfig.get('content_cloud_url') + '/api/contentcloud/v1/get-contents')

    return {
      fetch: fetchItems
    }

    function fetchItems (ids) {
      return API.post({}, {
        account_id: SdkConfig.get('account_id'),
        group_id: SdkConfig.get('group_id'),
        content_ids: ids
      })
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/content/content-api.js